export default __webpack_public_path__ + "static/media/headerImage.e9d76b85.jpg";